/** WCAG 2.4.1 — bypass blocks (aligned with mot-website-client skipLinks i18n). */
export const SKIP_LINKS_NAV_LABEL = {
  hebrew: 'דילוג לחלקי העמוד',
  english: 'Skip to page sections',
  arabic: 'تخطي إلى أقسام الصفحة',
};

export const SKIP_TO_MAIN_CONTENT = {
  hebrew: 'דלג לתוכן המרכזי',
  english: 'Skip to main content',
  arabic: 'انتقل إلى المحتوى الرئيسي',
};

export const SKIP_TO_TOP_NAV = {
  hebrew: 'דלג לתפריט העליון',
  english: 'Skip to top navigation',
  arabic: 'انتقل إلى القائمة العلوية',
};

/** Side panel: search tabs / mat-drawer (תפריט צד). */
export const SKIP_TO_SIDE_PANEL = {
  hebrew: 'דלג לתפריט הצד',
  english: 'Skip to side panel',
  arabic: 'انتقل إلى اللوحة الجانبية',
};
